import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0579a6e7"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center no-margin" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "images/Logo-aafiyat_White.png",
    style: {"height":"17vw"}
  })
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "agent-info no-margin" }, [
  /*#__PURE__*/_createElementVNode("small", { class: "text-small" }, "Olive House")
], -1))
const _hoisted_3 = {
  key: 1,
  class: "agent-info no-margin"
}
const _hoisted_4 = { class: "text-small" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_menu_toggle = _resolveComponent("ion-menu-toggle")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_menu = _resolveComponent("ion-menu")!
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_IonSplitPane = _resolveComponent("IonSplitPane")!
  const _component_ion_app = _resolveComponent("ion-app")!

  return (_openBlock(), _createBlock(_component_ion_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_IonSplitPane, { "content-id": "main-content" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_menu, {
            "content-id": "main-content",
            type: "overlay"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_content, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_list, { id: "inbox-list" }, {
                    default: _withCtx(() => [
                      _hoisted_1,
                      (_ctx.store.state.user != null)
                        ? (_openBlock(), _createBlock(_component_ion_note, { key: 0 }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.store.state.user.name), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _hoisted_2,
                      (_ctx.store.state.user != null)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                            _createElementVNode("small", _hoisted_4, _toDisplayString(_ctx.store.state.user.agent_type), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_5,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appPages, (p, i) => {
                        return (_openBlock(), _createBlock(_component_ion_menu_toggle, {
                          "auto-hide": "false",
                          key: i
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_item, {
                              onClick: ($event: any) => (_ctx.selectedIndex = i),
                              "router-direction": "root",
                              "router-link": p.url,
                              lines: "none",
                              detail: "false",
                              class: _normalizeClass(["hydrated", { selected: _ctx.selectedIndex === i }]),
                              style: _normalizeStyle(p.color)
                            }, {
                              default: _withCtx(() => [
                                (p.src)
                                  ? (_openBlock(), _createBlock(_component_ion_icon, {
                                      key: 0,
                                      src: p.src,
                                      slot: "start"
                                    }, null, 8, ["src"]))
                                  : (_openBlock(), _createBlock(_component_ion_icon, {
                                      key: 1,
                                      slot: "start",
                                      ios: p.iosIcon,
                                      md: p.mdIcon
                                    }, null, 8, ["ios", "md"])),
                                _createVNode(_component_ion_label, {
                                  class: "label-menu",
                                  style: _normalizeStyle(p.font)
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(p.title), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["style"])
                              ]),
                              _: 2
                            }, 1032, ["onClick", "router-link", "class", "style"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_router_outlet, { id: "main-content" })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}